module.exports = __webpack_public_path__ + "media/images/signatures/vasilenko-c2d25bcb8efdd31db13a98d740cdf4b1.png";